export default __webpack_public_path__ + "static/main_video-01-ec0b458bb04340febd74bd0d60c0e241.mp4";